// Libraries
import { popoverAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(popoverAnatomy.keys);

/**
 * Base style configuration for the Popover component.
 */
const baseStyle = definePartsStyle({
  content: {
    border: 'section',
    boxShadow: '0px 6.6501px 5.32008px rgba(35, 35, 45, 0.1), 0px 2.76726px 2.21381px rgba(195, 194, 209, 0.03)',
    borderRadius: 'md',
    w: 'fit-content',
  },
  popper: {
    zIndex: 'popover',
  },
});

/**
 * Chakra UI Popover theme configuration.
 */
export const Popover = defineMultiStyleConfig({ baseStyle });
